import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/page_icons/messages.svg'


const _withScopeId = n => (_pushScopeId("data-v-bfe4ced6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "messages" }
const _hoisted_2 = {
  id: "messages-container",
  class: "row"
}
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "row elements-centering" }
const _hoisted_5 = { class: "orange" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row elements-centering" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "messages icon",
    src: _imports_0
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("PAGE.MESSAGES")), 1)
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({
          'col-10': _ctx.user.canSendMessages,
          'col-8 offset-1': !_ctx.user.canSendMessages
        })
      }, [
        _createVNode(_component_Message)
      ], 2)
    ])
  ]))
}